import React from "react";
import { Card } from "react-bootstrap";
import { AvForm } from "availity-reactstrap-validation";

import TicketHeader from "../TicketHeader";
import AutomaticPrinting from "../AutomaticPrinting";
import { CardBody } from "reactstrap";
import InformationMode from "@pages/ApplicationSetting/General/InformationMode";

import { PrinterRowData } from "../../../types";

type UserCardType = {
    rowData: PrinterRowData;
};

function UserCard({ rowData }: UserCardType) {
    return (
        <Card style={{ fontSize: "17px" }}>
            <AvForm>
                <CardBody style={{ marginBottom: "45px" }}>
                    <AutomaticPrinting rowData={rowData} />
                    <div className="border-footer__clz p-2" />
                    <TicketHeader rowData={rowData} />
                    <div className="border-footer__clz p-2" />
                    <InformationMode rowData={rowData} />
                </CardBody>
            </AvForm>
        </Card>
    );
}

export default UserCard;
